/**
 * Louievale Cart Helper - Fixed Version 2
 * Handles grouped item removal for cart-remove-button web components
 * Now with better error handling for 422 errors
 */

(function() {
  'use strict';
  
  console.log('[LouievaleCart-v2] Cart helper initialized');
  
  // Function to handle grouped item removal
  async function handleGroupedRemoval(e, button) {
    // DON'T preventDefault here yet - we need to check first!
    
    console.log('[LouievaleCart-v2] Intercepted removal attempt');
    
    try {
      // Get current cart state
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      
      // Find the item being removed
      const removeUrl = button.getAttribute('href') || button.querySelector('a')?.getAttribute('href');
      if (!removeUrl) {
        console.log('[LouievaleCart-v2] No removal URL found');
        return true;
      }
      
      // Extract variant ID from URL
      const urlMatch = removeUrl.match(/id=([^:&]+)(?::([^&]+))?/);
      if (!urlMatch) {
        console.log('[LouievaleCart-v2] Could not parse variant ID from URL');
        return true;
      }
      
      const variantId = urlMatch[1];
      const lineKey = urlMatch[2] || '';
      
      // Find the item in cart
      const targetItem = cart.items.find(item => {
        const itemVariantId = String(item.variant_id || item.id);
        return itemVariantId === variantId;
      });
      
      if (!targetItem) {
        console.log('[LouievaleCart-v2] Item not found in cart');
        return true;
      }
      
      // Check if item has grouping properties
      const hasMainGroup = targetItem.properties && targetItem.properties._lv_main_order_group;
      const hasGroup = targetItem.properties && targetItem.properties._lv_order_group;
      
      if (!hasMainGroup && !hasGroup) {
        console.log('[LouievaleCart-v2] No group properties found, allowing normal removal');
        return true;  // RETURN TRUE - LET IT DELETE NORMALLY
      }
      
      // NOW we know it's grouped, so prevent default
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const groupId = targetItem.properties._lv_order_group || targetItem.properties._lv_main_order_group;
      console.log('[LouievaleCart-v2] Found grouped item, removing group:', groupId);
      
      // Find all items in the same group
      const itemsToRemove = cart.items.filter(item => {
        return item.properties && 
               (item.properties._lv_order_group === groupId || 
                item.properties._lv_main_order_group === groupId);
      });
      
      console.log(`[LouievaleCart-v2] Removing ${itemsToRemove.length} items from group`);
      
      // Create line_items array with all items set to 0 quantity
      // Using line_items array format which is more reliable than updates object
      const lineItems = cart.items.map((item, index) => {
        const shouldRemove = itemsToRemove.some(removeItem => 
          removeItem.key === item.key || 
          (removeItem.variant_id === item.variant_id && 
           JSON.stringify(removeItem.properties) === JSON.stringify(item.properties))
        );
        
        if (shouldRemove) {
          console.log(`[LouievaleCart-v2] Marking for removal: ${item.title}`);
          return { quantity: 0, id: item.key };
        }
        return { quantity: item.quantity, id: item.key };
      });
      
      // Filter to only include items that need updating
      const updates = {};
      lineItems.forEach((update, index) => {
        if (update.quantity === 0) {
          // Use the item key directly
          const item = cart.items[index];
          updates[item.key] = 0;
        }
      });
      
      console.log('[LouievaleCart-v2] Sending update:', updates);
      
      // Send update request using the updates object format
      try {
        const updateRes = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        
        if (!updateRes.ok) {
          const errorText = await updateRes.text();
          console.error('[LouievaleCart-v2] Update failed:', updateRes.status, errorText);
          
          // If we get a 422, try alternative removal method
          if (updateRes.status === 422) {
            console.log('[LouievaleCart-v2] Trying alternative removal via clear and re-add...');
            
            // Get all items that should remain
            const itemsToKeep = cart.items.filter(item => {
              return !itemsToRemove.some(removeItem => 
                removeItem.key === item.key || 
                (removeItem.variant_id === item.variant_id && 
                 JSON.stringify(removeItem.properties) === JSON.stringify(item.properties))
              );
            });
            
            // Clear cart
            await fetch('/cart/clear.js', { method: 'POST' });
            
            // Re-add items that should remain
            for (const item of itemsToKeep) {
              const addData = {
                id: item.variant_id,
                quantity: item.quantity
              };
              
              if (item.properties && Object.keys(item.properties).length > 0) {
                addData.properties = item.properties;
              }
              
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify(addData)
              });
            }
            
            console.log('[LouievaleCart-v2] Alternative removal complete');
          }
        } else {
          console.log('[LouievaleCart-v2] Update successful');
        }
        
        // Always reload to refresh cart display
        window.location.reload();
        
      } catch (err) {
        console.error('[LouievaleCart-v2] Failed to update cart:', err);
        // Allow default action on error
        return true;
      }
      
    } catch (err) {
      console.error('[LouievaleCart-v2] Error in grouped removal:', err);
      return true;
    }
    
    return false;
  }
  
  // Function to setup interception
  function setupInterception() {
    // Use event delegation on document body with capture phase
    document.addEventListener('click', async function(e) {
      // Check if clicked element is within a cart-remove-button
      const button = e.target.closest('cart-remove-button');
      if (!button) return;
      
      // Check if it's a remove link
      const link = e.target.closest('a[href*="/cart/change"]');
      if (!link) return;
      
      console.log('[LouievaleCart-v2] Cart remove button clicked');
      
      // Handle the grouped removal
      const shouldContinue = await handleGroupedRemoval(e, link);
      if (shouldContinue) {
        // Don't prevent default - let it delete normally
        console.log('[LouievaleCart-v2] Allowing normal deletion');
      }
    }, true); // Use capture phase
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupInterception);
  } else {
    setupInterception();
  }
  
  // Also setup for dynamic content (cart drawer)
  const observer = new MutationObserver(() => {
    // Interception is already set up globally, just log for debugging
    const buttons = document.querySelectorAll('cart-remove-button');
    if (buttons.length > 0) {
      console.log(`[LouievaleCart-v2] Found ${buttons.length} cart-remove-button elements`);
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();